const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const ALPHANUMERIC = `${LETTERS}0123456789`;
const PASSWORD_CHARS = `${ALPHANUMERIC}!@#$%^&*`;

const getRandomIndex = (alphabetLength: number): number => {
  const cryptoObj = typeof globalThis !== "undefined" && globalThis.crypto && typeof globalThis.crypto.getRandomValues === "function" ? globalThis.crypto : null;

  if (cryptoObj) {
    const array = new Uint8Array(1);
    cryptoObj.getRandomValues(array);
    return array[0] % alphabetLength;
  }

  return Math.floor(Math.random() * alphabetLength);
};

export const generateSecureToken = (length: number): string => {
  if (length <= 0) {
    throw new Error("Token length must be a positive integer");
  }

  let token = LETTERS.charAt(getRandomIndex(LETTERS.length));

  for (let i = 1; i < length; i++) {
    token += ALPHANUMERIC.charAt(getRandomIndex(ALPHANUMERIC.length));
  }

  return token;
};

export const generatePasswordFallback = (length: number): string => {
  if (length <= 0) {
    throw new Error("Password length must be a positive integer");
  }

  let password = LETTERS.charAt(getRandomIndex(LETTERS.length));

  for (let i = 1; i < length; i++) {
    password += PASSWORD_CHARS.charAt(getRandomIndex(PASSWORD_CHARS.length));
  }

  return password;
};

export const supportsSecureRandom = (): boolean => {
  return typeof globalThis !== "undefined" && !!globalThis.crypto && typeof globalThis.crypto.getRandomValues === "function";
};
